module.exports = __webpack_public_path__ + "img/antes_despues_19.961f8118.png";